/** @module SiteAdmin/Lookup/ReferencedByTable */
define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"underscore",
	"csi",
	"csi/config",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/reflection",
	"csi/table/TypeSwitchboardTable",
	"csi/xml",
	"csi/xml/Query"
], function(declare, Memory, _, csi, config, Renderer, locale, reflection, TypeSwitchboardTable, xml, Query) {

	var _ReferenceAttributeRenderer = declare(Renderer, {
		/**
		 * Get all the attributes that reference the parent node in context
		 */
		toValue: function(ctx, h) {
			var source = ctx.getNode();
			var targetUrl = ctx.getParentURL();
			var attributeIds = [];
			var attributes = xml.nodeGetAllAttributes(source, true);

			_.each(attributes, function(value, attribute) {
				if (value == targetUrl) {
					attributeIds.push(locale.typeId(source.$Type, attribute));
				}
			});

			const primaryName = _.isEmpty(attributeIds) ? "" : attributeIds.join(", ");

			return primaryName || locale.typeId(ctx.view.switchboardTargetType, ctx.view.attributeName[0]);
		},

		/**
		 * Avoid filtering and sorting
		 */
		getQuerySpec: function() {
			return null;
		},

		/**
		 * Make it string format, and left-aligned
		 */
		_getCSS: function(type, format) {
			return "attrString";
		}
	});

	return declare(TypeSwitchboardTable, {
		/**
		 * @override
		 * Initialize headings based on target type of view (or the source type of view if not yet set)
		*/
		onViewInitializeAttributes() {
			const {containerSourceType, containerTargetType, defView} = this;
			const type = containerTargetType || containerSourceType;

			defView.m_headings = [
				_.extend(defView.newHeading(), {m_id: type + ".Default", m_bCard: true}),
				_.extend(defView.newHeading(), {m_name: "ReflectionAttributeId", classRenderer: _ReferenceAttributeRenderer})
			];
		},

		/**
		 * @override
		 * Do not allow custom views if no data store for switchboard, unless performing custom view migration when view node is null
		 */
		supportsCustomViews: function() {
			return !this.getViewNode() || !!this.containerTypeStore;
		},

		/**
		 * @override
		 * Add type switchboard to plugin and set default value for container type to select from
		 */
		_resolveView: function() {
			const subtypedNode = this.getViewNode();
			if (subtypedNode) {
				// find reflection classes that have a reference to this node's class and subtype
				var subtype = config.getSubtypeName(subtypedNode.Subtype);
				var rcs = reflection.getNodeClass(subtypedNode).getIncomingOwnerClasses(subtype);

				if (rcs.length) {
					var data = _.map(rcs, function(rc) {
						return {id: rc.getType(), name: locale.type(rc.getType())};
					});

					data = csi.sort(data, "name");

					this.set("containerTypeStore", new Memory({data: data}));
					this.set("containerSourceType", data[0].id);
				}
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Show error message if no references to this subtype of item
		 */
		onViewStartBuild: function() {
			this.set("contentMessage", this.containerQuery ? null : locale.resource("NoLookupItemReference"));
		},

		/**
		 * @override
		 * Apply the filter based on the attributes that reference the view node's subtype
		 */
		_setContainerTargetTypeAttr: function(value) {
			var subtypedNode = this.getViewNode();
			var q = new Query();

			if (subtypedNode && value) {
				var type = subtypedNode.$Type;
				var subtype = config.getSubtypeName(subtypedNode.Subtype);
				var rc = reflection.getClass(value);
				const isSecondary = rc.isSecondary;
				if (isSecondary) {
					value = rc.domainClass.type;
				}

				var subquery = q.Or();

				var attributes = _.filter(rc.getRelations(true), function(rca) {
					var rcDest = rca.getDestinationClass(rc);
					return rcDest && (rcDest.getType() == type) && (rca.getSubtypeName() === subtype) && !rca.isHidden;
				});
				if (!isSecondary) {
					_.each(attributes, function(obj, i) {
						subquery.RefAttr(obj.getId(), xml.OP_EQUALS, subtypedNode.$URL);
					});
				} else {
					const localNames = [];
					_.each(attributes, function(obj, i) {
						subquery.RefAttr(obj.getId(), xml.OP_EQUALS, subtypedNode.$URL, "Child:Attributes");
						localNames.push(obj.getId());
					});
					this.set("attributeName", localNames);
				}
			}

			// if the target is null, don't issue the request to server at all
			this.set("containerQuery", value ? q : null);

			this.inherited(arguments);
		}
	});
});